module.exports = __webpack_public_path__ + "static/media/market_harborough.76ef4d11.png";